// @generated by protoc-gen-es v2.2.3 with parameter "target=ts"
// @generated from file annealing/compute/v1/service.proto (package annealing.compute.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv1";
import { fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv1";
import { file_google_api_annotations } from "../../../google/api/annotations_pb";
import { file_google_api_field_behavior } from "../../../google/api/field_behavior_pb";
import { file_google_api_resource } from "../../../google/api/resource_pb";
import type { OperationSchema } from "../../../google/longrunning/operations_pb";
import { file_google_longrunning_operations } from "../../../google/longrunning/operations_pb";
import type { Cluster, ClusterSchema, Machine, MachineSchema } from "./resources_pb";
import { file_annealing_compute_v1_resources } from "./resources_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file annealing/compute/v1/service.proto.
 */
export const file_annealing_compute_v1_service: GenFile = /*@__PURE__*/
  fileDesc("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", [file_google_api_annotations, file_google_api_field_behavior, file_google_api_resource, file_google_longrunning_operations, file_annealing_compute_v1_resources]);

/**
 * @generated from message annealing.compute.v1.GetMachineRequest
 */
export type GetMachineRequest = Message<"annealing.compute.v1.GetMachineRequest"> & {
  /**
   * @generated from field: string name = 1;
   */
  name: string;
};

/**
 * Describes the message annealing.compute.v1.GetMachineRequest.
 * Use `create(GetMachineRequestSchema)` to create a new message.
 */
export const GetMachineRequestSchema: GenMessage<GetMachineRequest> = /*@__PURE__*/
  messageDesc(file_annealing_compute_v1_service, 0);

/**
 * @generated from message annealing.compute.v1.ListMachinesRequest
 */
export type ListMachinesRequest = Message<"annealing.compute.v1.ListMachinesRequest"> & {
  /**
   * @generated from field: string parent = 1;
   */
  parent: string;

  /**
   * @generated from field: int32 page_size = 2;
   */
  pageSize: number;

  /**
   * @generated from field: string page_token = 3;
   */
  pageToken: string;
};

/**
 * Describes the message annealing.compute.v1.ListMachinesRequest.
 * Use `create(ListMachinesRequestSchema)` to create a new message.
 */
export const ListMachinesRequestSchema: GenMessage<ListMachinesRequest> = /*@__PURE__*/
  messageDesc(file_annealing_compute_v1_service, 1);

/**
 * @generated from message annealing.compute.v1.ListMachinesResponse
 */
export type ListMachinesResponse = Message<"annealing.compute.v1.ListMachinesResponse"> & {
  /**
   * @generated from field: repeated annealing.compute.v1.Machine machines = 1;
   */
  machines: Machine[];

  /**
   * @generated from field: string next_page_token = 2;
   */
  nextPageToken: string;

  /**
   * @generated from field: string previous_page_token = 3;
   */
  previousPageToken: string;

  /**
   * @generated from field: int32 total_size = 4;
   */
  totalSize: number;

  /**
   * @generated from field: int32 start_index = 5;
   */
  startIndex: number;
};

/**
 * Describes the message annealing.compute.v1.ListMachinesResponse.
 * Use `create(ListMachinesResponseSchema)` to create a new message.
 */
export const ListMachinesResponseSchema: GenMessage<ListMachinesResponse> = /*@__PURE__*/
  messageDesc(file_annealing_compute_v1_service, 2);

/**
 * @generated from message annealing.compute.v1.CreateMachineRequest
 */
export type CreateMachineRequest = Message<"annealing.compute.v1.CreateMachineRequest"> & {
  /**
   * @generated from field: string parent = 1;
   */
  parent: string;

  /**
   * @generated from field: annealing.compute.v1.Machine machine = 2;
   */
  machine?: Machine;

  /**
   * @generated from field: string machine_id = 3;
   */
  machineId: string;

  /**
   * @generated from field: bool validate_only = 4;
   */
  validateOnly: boolean;
};

/**
 * Describes the message annealing.compute.v1.CreateMachineRequest.
 * Use `create(CreateMachineRequestSchema)` to create a new message.
 */
export const CreateMachineRequestSchema: GenMessage<CreateMachineRequest> = /*@__PURE__*/
  messageDesc(file_annealing_compute_v1_service, 3);

/**
 * @generated from message annealing.compute.v1.DeleteMachineRequest
 */
export type DeleteMachineRequest = Message<"annealing.compute.v1.DeleteMachineRequest"> & {
  /**
   * @generated from field: string name = 1;
   */
  name: string;

  /**
   * @generated from field: bool validate_only = 2;
   */
  validateOnly: boolean;

  /**
   * @generated from field: bool allow_missing = 3;
   */
  allowMissing: boolean;

  /**
   * @generated from field: string etag = 4;
   */
  etag: string;
};

/**
 * Describes the message annealing.compute.v1.DeleteMachineRequest.
 * Use `create(DeleteMachineRequestSchema)` to create a new message.
 */
export const DeleteMachineRequestSchema: GenMessage<DeleteMachineRequest> = /*@__PURE__*/
  messageDesc(file_annealing_compute_v1_service, 4);

/**
 * @generated from message annealing.compute.v1.GetClusterRequest
 */
export type GetClusterRequest = Message<"annealing.compute.v1.GetClusterRequest"> & {
  /**
   * @generated from field: string name = 1;
   */
  name: string;
};

/**
 * Describes the message annealing.compute.v1.GetClusterRequest.
 * Use `create(GetClusterRequestSchema)` to create a new message.
 */
export const GetClusterRequestSchema: GenMessage<GetClusterRequest> = /*@__PURE__*/
  messageDesc(file_annealing_compute_v1_service, 5);

/**
 * @generated from message annealing.compute.v1.ListClustersRequest
 */
export type ListClustersRequest = Message<"annealing.compute.v1.ListClustersRequest"> & {
  /**
   * @generated from field: string parent = 1;
   */
  parent: string;

  /**
   * @generated from field: int32 page_size = 2;
   */
  pageSize: number;

  /**
   * @generated from field: string page_token = 3;
   */
  pageToken: string;
};

/**
 * Describes the message annealing.compute.v1.ListClustersRequest.
 * Use `create(ListClustersRequestSchema)` to create a new message.
 */
export const ListClustersRequestSchema: GenMessage<ListClustersRequest> = /*@__PURE__*/
  messageDesc(file_annealing_compute_v1_service, 6);

/**
 * @generated from message annealing.compute.v1.ListClustersResponse
 */
export type ListClustersResponse = Message<"annealing.compute.v1.ListClustersResponse"> & {
  /**
   * @generated from field: repeated annealing.compute.v1.Cluster clusters = 1;
   */
  clusters: Cluster[];

  /**
   * @generated from field: string next_page_token = 2;
   */
  nextPageToken: string;

  /**
   * @generated from field: string previous_page_token = 3;
   */
  previousPageToken: string;

  /**
   * @generated from field: int32 total_size = 4;
   */
  totalSize: number;

  /**
   * @generated from field: int32 start_index = 5;
   */
  startIndex: number;
};

/**
 * Describes the message annealing.compute.v1.ListClustersResponse.
 * Use `create(ListClustersResponseSchema)` to create a new message.
 */
export const ListClustersResponseSchema: GenMessage<ListClustersResponse> = /*@__PURE__*/
  messageDesc(file_annealing_compute_v1_service, 7);

/**
 * @generated from message annealing.compute.v1.CreateClusterRequest
 */
export type CreateClusterRequest = Message<"annealing.compute.v1.CreateClusterRequest"> & {
  /**
   * @generated from field: string parent = 1;
   */
  parent: string;

  /**
   * @generated from field: annealing.compute.v1.Cluster cluster = 2;
   */
  cluster?: Cluster;

  /**
   * @generated from field: string cluster_id = 3;
   */
  clusterId: string;

  /**
   * @generated from field: bool validate_only = 4;
   */
  validateOnly: boolean;
};

/**
 * Describes the message annealing.compute.v1.CreateClusterRequest.
 * Use `create(CreateClusterRequestSchema)` to create a new message.
 */
export const CreateClusterRequestSchema: GenMessage<CreateClusterRequest> = /*@__PURE__*/
  messageDesc(file_annealing_compute_v1_service, 8);

/**
 * @generated from message annealing.compute.v1.DeleteClusterRequest
 */
export type DeleteClusterRequest = Message<"annealing.compute.v1.DeleteClusterRequest"> & {
  /**
   * @generated from field: string name = 1;
   */
  name: string;

  /**
   * @generated from field: bool validate_only = 2;
   */
  validateOnly: boolean;

  /**
   * @generated from field: bool allow_missing = 3;
   */
  allowMissing: boolean;

  /**
   * @generated from field: string etag = 4;
   */
  etag: string;
};

/**
 * Describes the message annealing.compute.v1.DeleteClusterRequest.
 * Use `create(DeleteClusterRequestSchema)` to create a new message.
 */
export const DeleteClusterRequestSchema: GenMessage<DeleteClusterRequest> = /*@__PURE__*/
  messageDesc(file_annealing_compute_v1_service, 9);

/**
 * @generated from service annealing.compute.v1.ComputeService
 */
export const ComputeService: GenService<{
  /**
   * @generated from rpc annealing.compute.v1.ComputeService.GetMachine
   */
  getMachine: {
    methodKind: "unary";
    input: typeof GetMachineRequestSchema;
    output: typeof MachineSchema;
  },
  /**
   * @generated from rpc annealing.compute.v1.ComputeService.ListMachines
   */
  listMachines: {
    methodKind: "unary";
    input: typeof ListMachinesRequestSchema;
    output: typeof ListMachinesResponseSchema;
  },
  /**
   * @generated from rpc annealing.compute.v1.ComputeService.CreateMachine
   */
  createMachine: {
    methodKind: "unary";
    input: typeof CreateMachineRequestSchema;
    output: typeof OperationSchema;
  },
  /**
   * @generated from rpc annealing.compute.v1.ComputeService.DeleteMachine
   */
  deleteMachine: {
    methodKind: "unary";
    input: typeof DeleteMachineRequestSchema;
    output: typeof OperationSchema;
  },
  /**
   * @generated from rpc annealing.compute.v1.ComputeService.GetCluster
   */
  getCluster: {
    methodKind: "unary";
    input: typeof GetClusterRequestSchema;
    output: typeof ClusterSchema;
  },
  /**
   * @generated from rpc annealing.compute.v1.ComputeService.ListClusters
   */
  listClusters: {
    methodKind: "unary";
    input: typeof ListClustersRequestSchema;
    output: typeof ListClustersResponseSchema;
  },
  /**
   * @generated from rpc annealing.compute.v1.ComputeService.CreateCluster
   */
  createCluster: {
    methodKind: "unary";
    input: typeof CreateClusterRequestSchema;
    output: typeof OperationSchema;
  },
  /**
   * @generated from rpc annealing.compute.v1.ComputeService.DeleteCluster
   */
  deleteCluster: {
    methodKind: "unary";
    input: typeof DeleteClusterRequestSchema;
    output: typeof OperationSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_annealing_compute_v1_service, 0);

